// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-scroll-wrapper {
  max-height: 500px;
  overflow-y: auto;
  border-radius: 6px;
  transition: box-shadow 0.2s ease, border 0.2s ease;
}

.table-scroll-wrapper table thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 2;
}

.table-scroll-wrapper.scrolled {
  border: 2px solid #b0b0b0;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
}

.btn-dim {
  opacity: 0.5; /* make it dimmer */
  cursor: not-allowed; /* show blocked cursor */
}

table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;
}
table th,
table td {
  border: 1px solid #ddd;
  padding: 8px 12px;
  text-align: left;
  min-width: 120px;
  white-space: nowrap;
}
table th {
  background-color: #f5f5f5;
  font-weight: 600;
}
table tr:nth-child(even) {
  background-color: #fafafa;
}
table tr:hover {
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/Pages/smart_construction_app/Customer_V4/Estimation/FrontWallTable.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kDAAA;AACF;;AAEA;EACE,gBAAA;EACA,MAAA;EACA,yBAAA;EACA,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,uCAAA;AACF;;AACA;EACE,YAAA,EAAA,mBAAA;EACA,mBAAA,EAAA,wBAAA;AAEF;;AACC;EACC,WAAA;EACA,yBAAA;EACA,sBAAA;AAEF;AAAE;;EAEE,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AACE;EACE,yBAAA;EACA,gBAAA;AACJ;AAEE;EACE,yBAAA;AAAJ;AAGE;EACE,yBAAA;AADJ","sourcesContent":[".table-scroll-wrapper {\n  max-height: 500px;\n  overflow-y: auto;\n  border-radius: 6px;\n  transition: box-shadow 0.2s ease, border 0.2s ease;\n}\n \n.table-scroll-wrapper table thead th {\n  position: sticky;\n  top: 0;\n  background-color: #f8f9fa;\n  z-index: 2;\n}\n \n.table-scroll-wrapper.scrolled {\n  border: 2px solid #b0b0b0;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);\n}\n.btn-dim {\n  opacity: 0.5;           /* make it dimmer */\n  cursor: not-allowed;     /* show blocked cursor */\n}\n \n table {\n  width: 100%;\n  border-collapse: collapse;\n  border: 1px solid #ddd;\n\n  th,\n  td {\n    border: 1px solid #ddd;\n    padding: 8px 12px;\n    text-align: left;\n    min-width: 120px; // 🔹 Set your desired minimum width\n    white-space: nowrap; // Prevent text from wrapping\n  }\n\n  th {\n    background-color: #f5f5f5;\n    font-weight: 600;\n  }\n\n  tr:nth-child(even) {\n    background-color: #fafafa;\n  }\n\n  tr:hover {\n    background-color: #f0f0f0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
